// MAINNET

// const constants = {
//   tokenAddress: "0xbc003ce2b3e5dc97f56b3b42527ad1bd881902bc",  // singhCoin -- uni
//   // farmAddress: "0x3DCFb459f399307433a5a75765577ce1E361206B",  // FARM
//   farmAddress: "0xbaDe54DCd8F2885FDe29e25613F2Bc375a6554C4",  // FARM
//   lpAddress: "0x6cA79388a1fa4dDD5D0915d60E3437167Da90057",    // LP-DEFAULT
//   routerAddress: "0x55ced15e35b197374111016B65D81722b359cfCB", // ROUTER
//   ethAddress: "0x71aBbd6B628Da7874E9861B6A9E5D67B10Eec729",  //  WETL
// };
// export default constants;

// Mainnet
const constants = {
    tokenAddress: "0x867B96B33B2c13CC8cB78A9aA95420c6cD42C4c6",
    farmAddress: "0x849a941609560698031A0922242feeF6b268AE19",
    lpAddress: "0xA125dFF247c8aBAe18E7136dDDa1B1113EC6bA86",
    routerAddress: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
    ethAddress: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    usdtAddress: "0x55d398326f99059fF775485246999027B3197955"
};
export default constants;